var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    {
      staticClass: "back-button-container",
      on: {
        click: function($event) {
          return _vm.trackClick()
        }
      }
    },
    [
      _c("router-link", { staticClass: "back-button", attrs: { to: _vm.to } }, [
        _vm._v(_vm._s(_vm.$t("GLOBAL.BACK")))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }